import React, { useEffect, useRef, useState } from 'react'
import user from '../../../../images/jarvis/png/user.png'
import botIcon from '../../../../images/jarvis/png/chatbot.png'
import { Carousel } from 'antd'
import moment from 'moment'
import TypingEffect from '../typingEffect/TypingEffect'
import RenderGraph from '../helper/RenderGraph'
import RenderTable from '../helper/RenderTable'

const Message = React.memo(({ message = {}, handleNextQuestionClick, handleAstraChange, onNewMessage }) => {

    const conversationEndRef = useRef(null)

    const [userProfile, setUserProfile] = useState(localStorage.getItem('user_profile'))

    useEffect(() => {
        setUserProfile(localStorage.getItem('user_profile'))
    }, [])

    useEffect(() => {
        if (conversationEndRef.current) {
            conversationEndRef.current.scrollIntoView({ behavior: "smooth" })
        }
    }, [message])

    const handleOtherClick = () => {
        const newMessage = {
            question: "Switch to other Astra",
            answer: "Select from below",
            switch_astra: message.switch_options.map((ele) => ele)
        };
        onNewMessage(newMessage)
    }

    return (
        <>
            <style>
                {`
                .message {
                    position: relative;
                }

                .message:after {
                    position: absolute;
                    content: "";
                    width: 0;
                    height: 0;
                    border-style: solid;
                }

                .message.received {
                    background: #2a2624;
                    border-radius: 0px 10px 10px 10px;
                }

                .message.received:after {
                    border-width: 0px 10px 10px 0;
                    border-color: transparent #2a2624 transparent transparent;
                    top: 0;
                    left: -10px;
                }

                .message.sent {
                    background: #2a2624;
                    border-radius: 10px 0px 10px 10px;
                    padding: 15px;
                }

                .message.sent:after {
                    border-width: 0px 0 10px 10px;
                    border-color: transparent transparent transparent #2a2624;
                    top: 0;
                    right: -10px;
                }

                .time {
                    padding: 0 5px 0 5px;
                    color: #b8b8b8;
                    font-size: 12px;
                    text-align: end;
                    margin: 10px 0 0 0;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}
            </style>
            {/* send */}
            <div ref={conversationEndRef}></div>
            <div
                style={{
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "end",
                        gap: "8px",
                        width: "calc(100% - 50px)"
                    }}
                >
                    <div
                        class="message sent"
                    >
                        <p
                            style={{
                                fontSize: "12px",
                                color: "#fff",
                                textAlign: "left",
                                fontWeight: 450,
                                margin: 0
                            }}
                        >
                            {message?.question}
                        </p>
                    </div>
                    <div>
                        <img
                            src={userProfile || user}
                            onError={(e) => {
                                e.target.onerror = null
                                e.target.src = user
                            }}
                            height={35}
                            width={35}
                            style={{
                                borderRadius: "50%"
                            }}
                            alt='user'
                        />
                    </div>
                </div>
            </div>

            {/* receive */}
            {
                typeof (message?.answer) === 'string' ? (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "start",
                            gap: "8px",
                            marginTop: "20px",
                            marginBottom: "40px"
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                padding: "3px"
                            }}
                        >
                            <img
                                height={32}
                                src={botIcon}
                                alt='response-bot'
                            />
                        </div>
                        <div
                            style={{
                                width: "calc(100% - 50px)"
                            }}
                        >
                            <div
                                class="message received"
                            >
                                <div
                                    style={{
                                        padding: "12px 12px 0px 12px"
                                    }}
                                >
                                    <p
                                        style={{
                                            fontSize: "12px",
                                            color: "#fff",
                                            lineHeight: "1.7em",
                                            textAlign: "left",
                                            margin: 0,
                                        }}
                                    >
                                        {
                                            message?.isResponse ? (
                                                <TypingEffect text={message?.answer} />
                                            ) : (
                                                <p style={{ margin: 0, padding: 0 }}>{message?.answer}</p>
                                            )
                                        }
                                    </p>
                                </div>
                                <div
                                    style={{
                                        padding: "5px"
                                    }}
                                >
                                    {message?.graph && message?.graph?.graph_data?.length > 0 && (
                                        <Carousel
                                            arrows={false}
                                            infinite={true}
                                            fade={true}
                                            draggable={true}
                                            swipe={true}
                                            swipeToSlide={true}
                                        >
                                            {
                                                message?.graph?.graph_id !== 'cash_rotation_retailers' && (
                                                    <div>
                                                        <div>

                                                            <RenderGraph type={message?.graph?.gtype} id={message?.graph?.graph_id} title={message?.graph?.graph_title} data={message?.graph?.graph_data} />
                                                        </div>
                                                    </div>
                                                )
                                            }

                                            {
                                                message?.graph?.graph_id !== 'datewise_service_count' ? (
                                                    <div>
                                                        <RenderTable message={message} />
                                                    </div>
                                                ) : (
                                                    null
                                                )
                                            }
                                        </Carousel>
                                    )}
                                    <p
                                        class="time"
                                    >
                                        {moment(message?.timestamp).format('hh:mm a')}
                                    </p>
                                </div>
                            </div>
                            <div
                                style={{
                                    marginTop: "10px",
                                    marginBottom: "40px"
                                }}
                            >
                                {
                                    message?.next_questions?.map((ele) => (
                                        <div
                                            className='cursor-pointer'
                                            onClick={() => handleNextQuestionClick(ele)}
                                            style={{
                                                backgroundColor: "#2a2624",
                                                borderRadius: "10px",
                                                padding: "8px",
                                                border: "1px solid #c5c3c2",
                                                marginTop: "7px"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    textAlign: "left",
                                                    margin: 0
                                                }}
                                            >
                                                {ele}
                                            </p>
                                        </div>
                                    ))
                                }

                                {
                                    message?.switch_options?.length > 0 && (
                                        <div
                                            className='cursor-pointer'
                                            onClick={() => handleOtherClick()}
                                            style={{
                                                backgroundColor: "#2a2624",
                                                borderRadius: "10px",
                                                padding: "8px",
                                                border: "1px solid #c5c3c2",
                                                marginTop: "7px"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    textAlign: "left",
                                                    margin: 0
                                                }}
                                            >
                                                Switch to other Astra
                                            </p>
                                        </div>
                                    )
                                }

                                {
                                    message?.switch_astra?.map((ele) => (
                                        <div
                                            className='cursor-pointer'
                                            onClick={() => handleAstraChange(ele)}
                                            style={{
                                                backgroundColor: "#2a2624",
                                                borderRadius: "10px",
                                                padding: "8px",
                                                border: "1px solid #c5c3c2",
                                                marginTop: "7px"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontSize: "12px",
                                                    color: "#fff",
                                                    textAlign: "left",
                                                    margin: 0
                                                }}
                                            >
                                                {`${ele} Astra`}
                                            </p>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div >
                ) : (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            gap: "12px",
                            marginTop: "20px",
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                padding: "3px",
                                marginBottom: "50vh"
                            }}
                        >
                            <img
                                height={32}
                                src={botIcon}
                                alt='loading-bot'
                            />
                        </div>
                        <p
                            style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#fff",
                                lineHeight: "1.7em",
                                textAlign: "left",
                                margin: 0,
                            }}
                        >
                            {message?.answer}
                        </p>
                    </div>
                )
            }
        </>
    )
})

export default Message